<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách đối tác</h1>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.keyword"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.partnerCode"
              :options="listPartner"
              placeholder="Partner"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.level" :options="levelOptions" placeholder="Cấp độ"></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionCode"
              :options="regionOptions"
              placeholder="Vùng"
            ></Select2>
          </div>

          <div class="form-group">
            <Select2
              v-model="search.stateAgent"
              :options="statusOptions"
              placeholder="Trạng thái"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.verifyStatus"
              :options="certStatusOptions"
              placeholder="Trạng thái chứng thực"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.keeperId"
              :options="getListUserKeeper"
              placeholder="Người phụ trách"
            ></Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <p style="font-size: 14px">
              Tổng đối tác: <span class="text-primary">{{ pagination.total }}</span>
            </p>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="partnerList"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(totalDevice)="data">
                <p>Số lượng nhập: {{ data.item.totalDeviceImport }}</p>
                <p>Số lượng xuất: {{ data.item.totalDeviceActive }}</p>
              </template>

              <template #cell(account)="data">
                <p>{{ data.item.email }}</p>
                <p>{{ data.item.name }}</p>
                <p>Cấp độ: {{ data.item?.level }}</p>
                <p>Partner: {{ data.item?.partnerCode }}</p>
              </template>

              <template #cell(orderInfo)="data">
                <p>{{ data.item?.verifyAgentBankInfo?.name }}</p>
                <p>{{ data.item?.verifyAgentBankInfo?.taxCode }}</p>
                <p>{{ data.item?.verifyAgentBankInfo?.address }}</p>
              </template>

              <template #cell(region)="data">
                <span>{{ data.item.address }}</span
                >, <span>{{ data.item.districtName }}</span
                >,
                <span>{{ data.item.cityName }}</span>
              </template>

              <template #cell(personInCharge)="data">
                <p>{{ data.item?.keeper?.name }}</p>
                <p>{{ data.item?.keeper?.email }}</p>
              </template>

              <template #cell(status)="data">
                <span
                  class="badge"
                  :class="`badge-${transformColor(data.item.stateAgent, statusOptions)}`"
                >
                  {{ data.item.stateAgent | transformData(statusOptions) }}
                </span>
              </template>

              <template #cell(certStatus)="data">
                <span
                  class="badge"
                  :class="`badge-${transformColor(data.item.verifyStatus, certStatusOptions)}`"
                >
                  {{ data.item.verifyStatus | transformData(certStatusOptions) }}
                </span>
              </template>

              <template #cell(action)="{ item }">
                <a
                  :href="`/list-agent-partner-detail/${item.id}`"
                  target="_blank"
                  class="btn btn-sm btn-outline-primary"
                  >Chi tiết</a
                >
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import { AgentService } from '@/services/agent.service'
  import { StaffService } from '@/services/staff.service'
  import Config from '@/thirdParty/config'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'account', label: 'Tài khoản' },
    { key: 'orderInfo', label: 'Thông tin hóa đơn' },
    { key: 'totalDevice', label: 'Số lượng thiết bị' },
    { key: 'region', label: 'Vùng' },
    { key: 'personInCharge', label: 'Người phụ trách' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'certStatus', label: 'Trạng thái chứng thực' },
    { key: 'action', label: 'Hành động', class: 'text-center' },
  ]

  export default {
    data() {
      return {
        fieldsTable,
        filterTable: fieldsTable,
        partnerList: [],
        loading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        tbLoading: false,
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 100,
        },

        listPartner: [],
        levelOptions: [],
        regionOptions: [],
        getListUserKeeper: [],
        statusOptions: [
          { id: '0', text: 'Tất cả', color: 'secondary' },
          ...Config.statusOptionsAgentPartner,
        ],
        certStatusOptions: [
          { id: '0', text: 'Tất cả', color: 'secondary' },
          ...Config.certStatusOptions,
        ],
      }
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
      this.fetchPartner()
      this.fetchLevel()
      this.fetchDataStaff()
      this.getRegions()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    methods: {
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.regionOptions.push({
            id: '0',
            text: 'Tất cả',
          })
          data.data.map(e => {
            this.regionOptions.push({ id: e.code, text: e.name })
          })
        }
      },

      async fetchDataStaff() {
        try {
          this.showLoading = true
          const staffReponse = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          this.getListUserKeeper = staffReponse.data.map(item => {
            return { id: item.userId, text: `${item.name} - ${item.userName}` }
          })
        } catch (error) {
          console.log(error)
          this.showLoading = false
        } finally {
          this.showLoading = false
        }
      },
      async fetchPartner() {
        try {
          this.tbLoading = true
          const response = await AgentService.getListPartnerSort({
            page: 1,
            limit: 1000,
          })
          if (response.code === 1000) {
            this.listPartner = response.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.listPartner.unshift({ id: 0, text: 'Tất cả' })
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          console.error(error)
        } finally {
          this.tbLoading = false
        }
      },

      async fetchLevel() {
        try {
          this.tbLoading = true
          const response = await AgentService.getListLevelAgent({})
          if (response.code === 1000) {
            this.levelOptions = response.data.map(e => {
              return {
                id: e.level,
                text: e.name,
              }
            })
            this.levelOptions.unshift({ id: 0, text: 'Tất cả' })
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          console.error(error)
        } finally {
          this.tbLoading = false
        }
      },
      transformColor(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].color
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        await this.fetchData()
      },

      cleanObject(obj) {
        const hasInvalidFields = Object.values(obj).some(function (value) {
          return value === 0 || value === '0' || value === '' || value === null
        })

        if (!hasInvalidFields) {
          return obj
        }

        const cleanedObj = {}
        for (const key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key]
            if (value !== 0 && value !== '0' && value !== '' && value !== null) {
              cleanedObj[key] = value
            }
          }
        }

        return cleanedObj
      },
      async fetchData() {
        try {
          this.tbLoading = true

          const payload = this.cleanObject({
            ...this.search,
            showReportDevice: true,
            sortResultList: [{ field: 'createdDate', direction: 'DESC' }],
          })

          const response = await AgentService.getListAgentPartner(payload)
          if (response.code === 1000) {
            this.partnerList = response.data
            this.pagination.total = response?.totalPage?.total || 0
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          console.error(error)
        } finally {
          this.tbLoading = false
        }
      },
    },
  }
</script>

<style></style>
